module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', {
    staticClass: "edit-user gh-box"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-4": "",
      "right-align": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "subheading"
  }, [_c('p', {
    staticClass: "title semibold"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + " (" + _vm._s(_vm.user.id) + ")")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.user.email
    }
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('p', [_vm._v("Last Log In: " + _vm._s(_vm.user.login_at))]), _vm._v(" "), _c('p', [_vm._v("Last Order: " + _vm._s(_vm.user.last_ordered_at))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.number_of_orders) + " Total Orders")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('login-info', {
    attrs: {
      "user": _vm.user
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('shipping-address', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('billing-address', {
    attrs: {
      "user": _vm.user
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3daf57d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/show.vue
// module id = 669
// module chunks = 1